import { render } from "./signupThanks.vue?vue&type=template&id=6897669b"
import script from "./signupThanks.vue?vue&type=script&lang=js"
export * from "./signupThanks.vue?vue&type=script&lang=js"

import "./signupThanks.vue?vue&type=style&index=0&id=6897669b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/signupThanks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6897669b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6897669b', __exports__)) {
    api.reload('6897669b', __exports__)
  }
  
  module.hot.accept("./signupThanks.vue?vue&type=template&id=6897669b", () => {
    api.rerender('6897669b', render)
  })

}


export default __exports__